import { render, staticRenderFns } from "./DashboardStatues.vue?vue&type=template&id=f48a6ea0"
import script from "./DashboardStatues.vue?vue&type=script&lang=js"
export * from "./DashboardStatues.vue?vue&type=script&lang=js"
import style0 from "./DashboardStatues.vue?vue&type=style&index=0&id=f48a6ea0&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f48a6ea0')) {
      api.createRecord('f48a6ea0', component.options)
    } else {
      api.reload('f48a6ea0', component.options)
    }
    module.hot.accept("./DashboardStatues.vue?vue&type=template&id=f48a6ea0", function () {
      api.rerender('f48a6ea0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardStatues.vue"
export default component.exports